import { fetchAll, fetchOne } from './fetch';

export default {
  ...fetchAll('stock'),
  ...fetchOne('stock')
};
